import { Injectable } from '@angular/core';

/*
  Generated class for the SettingsProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SettingsProvider {

  setLocal(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  getLocal(key: string): string {
    return localStorage.getItem(key);
  }

  setLocalBool(key: string, value: boolean) {
    const stringValue = value === true ? 'true' : 'false';
    this.setLocal(key, stringValue);
  }

  /***
   * Returns null if key has not been set yet.
   */
  getLocalBool(key: string): boolean {
    const stringValue = this.getLocal(key);
    return isNullOrUndefined(stringValue) ? null : stringValue === 'true';
  }


  setLocalNumber(key: string, value: number) {
    const stringValue = value.toString(10);
    this.setLocal(key, stringValue);
  }

  /***
   * Returns null if key has not been set yet.
   */
  getLocalNumber(key: string): number {
    const stringValue = this.getLocal(key);
    return isNullOrUndefined(stringValue) ? null : parseInt(stringValue, 10);
  }
}

function isNullOrUndefined(value: any): boolean {
  return value === null || typeof value === 'undefined';
}



// WEBPACK FOOTER //
// ./src/providers/settings/settings.ts